import { ActionTypes } from './enums';

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

const defaultRepSearch = {
    levels: [0],
    roles: [0, 1]
};

export const calcMaximumRepresentativeSearch = (cards, actions) => {
    const searches = cards
        .map(card => card.representativeSearch)
        .concat(actions.map(action => action.representativeSearch))
        .filter(search => !!search && !!search.levels && search.levels.length);
    if (actions.find(a => a.type.toLowerCase() === ActionTypes.CheckRepPosition))
        searches.push(defaultRepSearch);
    const levels = [].concat.apply([], searches.map(s => s.levels)).filter(onlyUnique);
    const roles = [].concat.apply([], searches.map(s => s.roles)).filter(onlyUnique);
    return { levels, roles };
};
